import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[class-hover]',
    standalone: false
})
export class ClassHoverDirective {

	@Input('class-hover')
	public classHover: any;

	@HostListener('mouseenter') onMouseEnter() {
		this._elementRef.nativeElement.classList.add(this.classHover);
	}

	@HostListener('mouseleave') onMouseLeave() {
		this._elementRef.nativeElement.classList.remove(this.classHover);
	}

	constructor(
		private _elementRef: ElementRef,
	) { }
}